import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import actions from '../constants';

const useRefreshCohort = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ isNew }) => handler({
    type: actions.FETCH_COHORT, category, code, isNew,
  }), [category, code]);
};

export default {
  useRefreshCohort,
  useUpdateCohortCancel: (category, { code }) => events.useDispatchByCode(actions.UPDATE_COHORT_CANCEL, category, code),
};
